import {
    ClickMapQuestion,
    DragAndDropQuestion,
    LinkQuestion,
    MultipleChoiceQuestion,
} from '../../models';
import { QuestionType } from '../enums';

export const questionData = [
    //1 new audio
    {
        type: QuestionType.ClickMap,
        image: require('../../assets/questionsAssets/images/wildlife-on-the-road.jpg'),
        video: '',
        points: 1,
        text: 'What wildlife could we see on the road?',
        questionAudio: require('../../assets/audio/Ages_5-7_Q&A_Audio_5-7_1Q.wav'),
        descriptionAudio: require('../../assets/audio/Ages_5-7_Q&A_Audio_5-7_1A.wav'),
        descriptionConditions: '',
        description:
            'There are a lot of animals that you might see on the road so always be on the lookout!',
        descriptionImage: '',
        answers: [
            {
                position: {
                    x: 0.008,
                    y: 0.4,
                },
                width: 0.14,
                height: 0.3,
                color: 'transparent',
                selected: false,
                isCorrect: true,
            },
            {
                position: {
                    x: 0.145,
                    y: 0.3,
                },
                width: 0.32,
                height: 0.28,
                color: 'transparent',
                selected: false,
                isCorrect: false,
            },
            {
                position: {
                    x: 0.19,
                    y: 0.58,
                },
                width: 0.2,
                height: 0.25,
                color: 'transparent',
                selected: false,
                isCorrect: true,
            },
            {
                position: {
                    x: 0.71,
                    y: 0.33,
                },
                width: 0.27,
                height: 0.27,
                color: 'transparent',
                selected: false,
                isCorrect: true,
            },
            {
                position: {
                    x: 0.8,
                    y: 0.61,
                },
                width: 0.2,
                height: 0.3,
                color: 'transparent',
                selected: false,
                isCorrect: true,
            },
            {
                position: {
                    x: 0.5,
                    y: 0.35,
                },
                width: 0.16,
                height: 0.25,
                color: 'transparent',
                selected: false,
                isCorrect: true,
            },
            {
                position: {
                    x: 0.52,
                    y: 0.54,
                },
                width: 0.22,
                height: 0.25,
                color: 'transparent',
                selected: false,
                isCorrect: true,
            },
        ],
    } as ClickMapQuestion,
    //2 new audio
    {
        type: QuestionType.MultipleChoice,
        image: '',
        video: require('../../assets/questionsAssets/videos/QUIZ-Film_danger-on-roads_V3.mp4'),
        points: 1,
        text: 'Click below on the road hazards that you saw in the video.',
        questionAudio: require('../../assets/audio/Ages_5-7_Q&A_Audio_5-7_2Q.wav'),
        descriptionAudio: require('../../assets/audio/Ages_5-7_Q&A_Audio_5-7_2A.wav'),
        descriptionConditions: '',
        description:
            'There can be many hazards on the road, so always be on the lookout!',
        descriptionImage: '',
        answers: [
            {
                text: 'Roadworks',
                isCorrect: true,
                answer: false,
                background: '',
            },
            {
                text: 'Fallen Tree',
                isCorrect: true,
                answer: false,
                background: '',
            },
            {
                text: 'Broken down car',
                isCorrect: true,
                answer: false,
                background: '',
            },
            {
                text: 'Water on the road',
                isCorrect: true,
                answer: false,
                background: '',
            },
        ],
    } as MultipleChoiceQuestion,
    //3 need audio, image to answer
    {
        type: QuestionType.DragAndDrop,
        image: require('../../assets/images/match-truck_A2.png'),
        video: '',
        points: 1,
        text: 'Drag the parts into place to help build iNSTRUCKTA!',
        questionAudio: require('../../assets/audio/Ages_5-7_Q&A_Audio_5-7_3Q.wav'),
        descriptionAudio: '',
        descriptionConditions: 'onlyImg',
        description: '',
        descriptionImage: require('../../assets/questionsAssets/images/match-truck_B.png'),
        answers: [
            {
                title: '',
                detail: require('../../assets/images/match-truck_A1.png'),
                width: 0.107,
                height: 0.27,
                current: {
                    left: '',
                    top: '',
                },
                target: 0,
                from: {
                    x: 0,
                    y: 0,
                },
                to: {
                    x: 0.751,
                    y: 0.73,
                },
                isDropped: false,
                background: 'transparent',
            },
            {
                title: '',
                detail: require('../../assets/images/match-truck_A3.png'),
                width: 0.8,
                height: 1,
                current: {
                    left: '',
                    top: '',
                },
                target: 0,
                from: {
                    x: 0,
                    y: 0,
                },
                to: {
                    x: 0,
                    y: 0,
                },
                isCorrect: false,
                background: 'transparent',
            },
            {
                title: '',
                detail: require('../../assets/images/match-truck_A7.png'),
                width: 0.059,
                height: 0.37,
                current: {
                    left: '',
                    top: '',
                },
                target: 0,
                from: {
                    x: 0,
                    y: 0,
                },
                to: {
                    x: 0.913,
                    y: 0.29,
                },
                isCorrect: false,
                background: 'transparent',
            },
            {
                title: '',
                detail: require('../../assets/images/match-truck_A4.png'),
                width: 0.065,
                height: 0.27,
                current: {
                    left: '',
                    top: '',
                },
                target: 0,
                from: {
                    x: 0,
                    y: 0,
                },
                to: {
                    x: 0.875,
                    y: 0.73,
                },
                isCorrect: false,
                background: 'transparent',
            },
            {
                title: '',
                detail: require('../../assets/images/match-truck_A5.png'),
                width: 0.155,
                height: 0.27,
                current: {
                    left: '',
                    top: '',
                },
                target: 0,
                from: {
                    x: 0,
                    y: 0,
                },
                to: {
                    x: 0.59,
                    y: 0.735,
                },
                isCorrect: false,
                background: 'transparent',
            },
        ],
    } as DragAndDropQuestion,
    //4
    {
        type: QuestionType.MultipleChoice,
        image: require('../../assets/questionsAssets/images/5-7_4_safest-places-road-cross.jpg'),
        video: '',
        points: 1,
        text: 'Where are the safest places to cross the road?',
        questionAudio: require('../../assets/audio/Ages_5-7_Q&A_Audio_5-7_4Q.wav'),
        descriptionAudio: require('../../assets/audio/Ages_5-7_Q&A_Audio_5-7_4A.wav'),
        descriptionConditions: 'imgFirst',
        description:
            "The safest places to cross the road are crosswalks, traffic lights and with a crosswalk attendant's help.",
        descriptionImage: require('../../assets/questionsAssets/images/safest-places-road-cross_answer.jpg'),
        answers: [
            {
                text: 'Cross walk',
                isCorrect: true,
                answer: false,
                background: '',
            },
            {
                text: 'Traffic lights',
                isCorrect: true,
                answer: false,
                background: '',
            },
            {
                text: 'Crosswalk attendant',
                isCorrect: true,
                answer: false,
                background: '',
            },
        ],
    } as MultipleChoiceQuestion,
    // 5 true/false
    {
        type: QuestionType.MultipleChoice,
        image: require('../../assets/questionsAssets/images/crossing-road.jpg'),
        video: '',
        points: 1,
        text: 'Before you cross the road you should stop, look and listen and only cross when its safe.',
        questionAudio: require('../../assets/audio/Ages_5-7_Q&A_Audio_5-7_5Q.wav'),
        descriptionAudio: require('../../assets/audio/Ages_5-7_Q&A_Audio_5-7_5A.wav'),
        descriptionConditions: '',
        description:
            '• Stop before you cross the road <br>• Look for traffic <br>• Listen for traffic<br>• Look left, then right, then left again <br>• Wait for traffic going in both directions to stop<br>• Keep looking and listening and only cross when it is safe',
        descriptionImage: '',
        answers: [
            { text: 'True', isCorrect: true, answer: false, background: '' },
            { text: 'False', isCorrect: false, answer: false, background: '' },
        ],
    } as MultipleChoiceQuestion,
    //6 true/false
    {
        type: QuestionType.MultipleChoice,
        image: require('../../assets/questionsAssets/images/child-crossing.jpg'),
        video: '',
        points: 1,
        text: ' It is not safe to cross the road until the truck has come to a complete stop.',
        questionAudio: require('../../assets/audio/Ages_5-7_Q&A_Audio_5-7_6Q.wav'),
        descriptionAudio: require('../../assets/audio/Ages_5-7_Q&A_Audio_5-7_6A.wav'),
        descriptionConditions: '',
        description:
            'Trucks are big and heavy and will take longer to stop than a car.<br>Always make sure that the truck has stopped, and the driver has seen you before you cross the road.',
        descriptionImage: '',
        answers: [
            { text: 'True', isCorrect: true, answer: false, background: '' },
            { text: 'False', isCorrect: false, answer: false, background: '' },
        ],
    } as MultipleChoiceQuestion,
    //7
    {
        type: QuestionType.ClickMap,
        image: require('../../assets/questionsAssets/images/trucks-can-carry.jpg'),
        video: '',
        points: 1,
        text: 'Trucks can carry all sorts of everyday items, touch or click on the items that you think have been carried by a truck.',
        questionAudio: require('../../assets/audio/Ages_5-7_Q&A_Audio_5-7_7Q.wav'),
        descriptionAudio: require('../../assets/audio/Ages_5-7_Q&A_Audio_5-7_7A.wav'),
        descriptionConditions: '',
        description: 'Trucks deliver almost everything we use and eat.',
        descriptionImage: '',
        answers: [
            {
                position: {
                    x: 0.7,
                    y: 0.22,
                },
                width: 0.25,
                height: 0.25,
                color: 'transparent',
                selected: false,
                isCorrect: true,
            },
            {
                position: {
                    x: 0.228,
                    y: 0.42,
                },
                width: 0.18,
                height: 0.15,
                color: 'transparent',
                selected: false,
                isCorrect: true,
            },
            {
                position: {
                    x: 0.505,
                    y: 0.4,
                },
                width: 0.2,
                height: 0.17,

                color: 'transparent',
                selected: false,
                isCorrect: true,
            },
            {
                position: {
                    x: 0.405,
                    y: 0.31,
                },
                width: 0.1,
                height: 0.32,

                color: 'transparent',
                selected: false,
                isCorrect: true,
            },
            {
                position: {
                    x: 0.505,
                    y: 0.57,
                },
                width: 0.2,
                height: 0.25,

                color: 'transparent',
                selected: false,
                isCorrect: true,
            },
            {
                position: {
                    x: 0.8,
                    y: 0.47,
                },
                width: 0.18,
                height: 0.3,

                color: 'transparent',
                selected: false,
                isCorrect: true,
            },
            {
                position: {
                    x: 0.02,
                    y: 0.32,
                },
                width: 0.21,
                height: 0.25,

                color: 'transparent',
                selected: false,
                isCorrect: true,
            },
            {
                position: {
                    x: 0.015,
                    y: 0.57,
                },
                width: 0.39,
                height: 0.18,

                color: 'transparent',
                selected: false,
                isCorrect: true,
            },
            {
                position: {
                    x: 0.06,
                    y: 0.75,
                },
                width: 0.31,
                height: 0.21,

                color: 'transparent',
                selected: false,
                isCorrect: true,
            },
        ],
    } as ClickMapQuestion,
    //8
    {
        type: QuestionType.Link,
        image: '',
        video: '',
        points: 1,
        text: 'See if you can match up the trucks and the loads that they carry. To answer, touch or click the truck on the left, and then the load you think it carries on the right. Press check when you are done.',
        questionAudio: require('../../assets/audio/Ages_5-7_Q&A_Audio_5-7_8Q.wav'),
        descriptionAudio: require('../../assets/audio/Ages_5-7_Q&A_Audio_5-7_8A.wav'),
        descriptionImage: require('../../assets/questionsAssets/images/type1-answer.png'),
        descriptionConditions: 'imgFirst',
        description:
            'There are many different types of trucks made to carry all kinds of things.',
        answers: [
            {
                start: {
                    id: 1,
                    text: '',
                    image: require('../../assets/typesOfTrucks/5-7_8_start-1.png'),
                },
                end: {
                    id: 2,
                    text: '',
                    image: require('../../assets/typesOfTrucks/5-7_8_end-1.png'),
                },
            },
            {
                start: {
                    id: 2,
                    text: '',
                    image: require('../../assets/typesOfTrucks/5-7_8_start-2.png'),
                },
                end: {
                    id: 4,
                    text: '',
                    image: require('../../assets/typesOfTrucks/5-7_8_end-2.png'),
                },
            },
            {
                start: {
                    id: 3,
                    text: '',
                    image: require('../../assets/typesOfTrucks/5-7_8_start-3.png'),
                },
                end: {
                    id: 1,
                    text: '',
                    image: require('../../assets/typesOfTrucks/5-7_8_end-3.png'),
                },
            },
            {
                start: {
                    id: 4,
                    text: '',
                    image: require('../../assets/typesOfTrucks/5-7_8_start-4.png'),
                },
                end: {
                    id: 5,
                    text: '',
                    image: require('../../assets/typesOfTrucks/5-7_8_end-4.png'),
                },
            },
            {
                start: {
                    id: 5,
                    text: '',
                    image: require('../../assets/typesOfTrucks/5-7_8_start-5.png'),
                },
                end: {
                    id: 3,
                    text: '',
                    image: require('../../assets/typesOfTrucks/5-7_8_end-5.png'),
                },
            },
        ],
    } as LinkQuestion,
    //9 true/false
    {
        type: QuestionType.MultipleChoice,
        image: require('../../assets/questionsAssets/images/in-blind-spot-front.jpg'),
        video: '',
        points: 1,
        text: 'Do you think the truck driver can see the child?',
        questionAudio: require('../../assets/audio/Ages_5-7_Q&A_Audio_5-7_9Q.wav'),
        descriptionAudio: require('../../assets/audio/Ages_5-7_Q&A_Audio_5-7_9A.wav'),
        descriptionConditions: '',
        description:
            "Trucks are big and there are lots of blind spots where the driver can not see you,<br> if you can't see the driver then he can't see you either.",
        descriptionImage: '',
        answers: [
            { text: 'Yes', isCorrect: false, answer: false, background: '' },
            { text: 'No', isCorrect: true, answer: false, background: '' },
        ],
    } as MultipleChoiceQuestion,
    //10 true/false
    {
        type: QuestionType.MultipleChoice,
        image: require('../../assets/questionsAssets/images/in-blind-spot-rear.jpg'),
        video: '',
        points: 1,
        text: "Are the children in the truck's blind spot?",
        questionAudio: require('../../assets/audio/Ages_5-7_Q&A_Audio_5-7_10Q.wav'),
        descriptionAudio: require('../../assets/audio/Ages_5-7_Q&A_Audio_5-7_10A.wav'),
        descriptionConditions: '',
        description:
            "Trucks are big and there are lots of blind spots where the driver can not see you.<br> It's not safe to be in a truck's blind spots.",
        descriptionImage: '',
        answers: [
            { text: 'Yes', isCorrect: true, answer: false, background: '' },
            { text: 'No', isCorrect: false, answer: false, background: '' },
        ],
    } as MultipleChoiceQuestion,
    //11 true/false
    {
        type: QuestionType.MultipleChoice,
        image: require('../../assets/questionsAssets/images/trucks-are-big.jpg'),
        video: '',
        points: 1,
        text: 'Trucks are very big and high. Can the driver always see everything around them?',
        questionAudio: require('../../assets/audio/Ages_5-7_Q&A_Audio_5-7_11Q.wav'),
        descriptionAudio: require('../../assets/audio/Ages_5-7_Q&A_Audio_5-7_11A.wav'),
        descriptionConditions: '',
        description:
            'Trucks have big blind spots, and the driver can not always<br>see everything around them.',
        descriptionImage: '',
        answers: [
            { text: 'Yes', isCorrect: false, answer: false, background: '' },
            { text: 'No', isCorrect: true, answer: false, background: '' },
        ],
    } as MultipleChoiceQuestion,
    //12  true/false
    {
        type: QuestionType.MultipleChoice,
        image: require('../../assets/questionsAssets/images/playing-near-road-driveways.jpg'),
        video: '',
        points: 1,
        text: 'It is safe to play near the road or on driveways?',
        questionAudio: require('../../assets/audio/Ages_5-7_Q&A_Audio_5-7_12Q.wav'),
        descriptionAudio: require('../../assets/audio/Ages_5-7_Q&A_Audio_5-7_12A.wav'),
        descriptionConditions: 'imgFirst',
        description:
            ' Playing near the road is very dangerous.<br>Avoid playing on or near roads and driveways as vehicles may not see you in time to stop.',
        descriptionImage: require('../../assets/questionsAssets/images/playing-near-road-driveways_answer.jpg'),
        answers: [
            { text: 'Yes', isCorrect: false, answer: false, background: '' },
            { text: 'No', isCorrect: true, answer: false, background: '' },
        ],
    } as MultipleChoiceQuestion,
    //13  true/false
    {
        type: QuestionType.MultipleChoice,
        image: require('../../assets/questionsAssets/images/animal-crash.jpg'),
        video: '',
        points: 1,
        text: '1 in 7 crashes on country roads involve an animal.',
        questionAudio: require('../../assets/audio/Ages_5-7_Q&A_Audio_5-7_13Q.wav'),
        descriptionAudio: require('../../assets/audio/Ages_5-7_Q&A_Audio_5-7_13A.wav'),
        descriptionConditions: '',
        description:
            'When driving always remember to be alert and keep an eye out for animals, stay within speed limits; drive to conditions, be cautious around water points like dams and creeks and avoid driving at dawn and dusk.',
        descriptionImage: '',
        answers: [
            { text: 'True', isCorrect: true, answer: false, background: '' },
            { text: 'False', isCorrect: false, answer: false, background: '' },
        ],
    } as MultipleChoiceQuestion,
    // 14
    {
        type: QuestionType.ClickMap,
        image: require('../../assets/questionsAssets/images/5-7_14_who-can-be-drivers.jpg'),
        video: '',
        points: 1,
        text: 'Which of these people can be truck drivers?',
        questionAudio: require('../../assets/audio/Ages_5-7_Q&A_Audio_5-7_14Q.wav'),
        descriptionAudio: require('../../assets/audio/Ages_5-7_Q&A_Audio_5-7_14A.wav'),
        descriptionConditions: '',
        description:
            'Anyone with the right license and training can become a truck driver!',
        descriptionImage: '',
        answers: [
            {
                position: {
                    x: 0.23,
                    y: 0.3,
                },
                width: 0.15,
                height: 0.65,
                color: 'transparent',
                selected: false,
                isCorrect: true,
            },
            {
                position: {
                    x: 0.38,
                    y: 0.3,
                },
                width: 0.15,
                height: 0.65,
                color: 'transparent',
                selected: false,
                isCorrect: true,
            },
            {
                position: {
                    x: 0.53,
                    y: 0.3,
                },
                width: 0.15,
                height: 0.65,
                color: 'transparent',
                selected: false,
                isCorrect: true,
            },
            {
                position: {
                    x: 0.68,
                    y: 0.3,
                },
                width: 0.15,
                height: 0.65,
                color: 'transparent',
                selected: false,
                isCorrect: true,
            },
        ],
    } as ClickMapQuestion,
];
